const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');

class CloverTransactionRefundRequestRecord extends AbstractCloverRequestRecord {
    /**
     * @param {string} paymentId
     * @param {number} amount
     * @param {boolean} fullRefund
     */
    constructor(paymentId, amount, fullRefund) {
        if (!paymentId || paymentId.trim() === '') {
            throw new Error('paymentId is required');
        }
        if (!amount || !Number.isInteger(amount)) {
            throw new Error('amount is required');
        }
        if (typeof fullRefund !== 'boolean') {
            throw new Error('fullRefund is required');
        }
        // @link https://sandbox.dev.clover.com/connect/v1/payments/{paymentId}/refunds
        const url = '/connect/v1/payments/' + paymentId + '/refunds';
        super(
            'POST',
            url
        );

        // We always have to send a +ve integer to the Clover API and the amount provided is -ve.
        // Note - amount is ignored anyway if fullRefund is sent.
        amount *= -1;

        this.data = {
            amount,
            fullRefund,
        };
    }
}

module.exports = CloverTransactionRefundRequestRecord;
